import React from 'react';
import { Gift } from 'lucide-react';
const bonuses = [{
  title: 'Client Communication Toolkit™',
  description: 'A complete communication system with professional message templates, appointment reminders, follow-up communications, motivation messages, and client engagement resources to improve communication before, during, and after every consultation.'
}, {
  title: 'Professional Forms Vault™',
  description: 'A complete library of printable professional forms including client registration forms, medical history templates, food journals, lifestyle questionnaires, consent forms, progress reviews, and consultation documentation—ready to use from day one.'
}, {
  title: 'Healthy Habit Coaching System™',
  description: 'A practical coaching system designed to help clients build long-term healthy habits through accountability tools, habit trackers, motivation worksheets, reflection exercises, and structured behavior change frameworks.'
}, {
  title: 'Social Media Content for Nutritionists™',
  description: 'A ready-to-use content system with educational post ideas, carousel templates, content calendars, caption examples, nutrition tips, and authority-building resources to help you consistently attract more clients online.'
}, {
  title: 'Premium Client Experience System™',
  description: 'A complete framework to create an exceptional client experience with professional onboarding systems, welcome resources, follow-up processes, consultation workflows, and retention strategies that increase client satisfaction and loyalty.'
}];
export function BonusSection() {
  return <>
      <section className="py-8 px-4 bg-white border-y-4 border-brand-gold/30" data-id="element-14">
        <div className="max-w-4xl mx-auto" data-id="element-15">
          <div className="text-center mb-6" data-id="element-16">
            <h2 className="text-2xl sm:text-3xl font-serif font-extrabold text-brand-graphite mb-2 uppercase" data-id="element-17">
              5 PREMIUM BONUSES INCLUDED
            </h2>
            <p className="text-base text-brand-graphite/90 font-medium leading-snug max-w-3xl mx-auto" data-id="element-18">
              You'll also receive 5 premium bonuses designed to help you save
              even more time, improve your client experience, and organize your
              nutrition practice like a true professional.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-5" data-id="element-19">
            {bonuses.map((bonus, i) => <div key={i} className="bg-brand-cream border-2 border-brand-gold/50 p-4 rounded-lg text-center shadow-sm" data-id="element-20">
                <div className="w-10 h-10 mx-auto bg-brand-gold/20 rounded-full flex items-center justify-center mb-2" data-id="element-21">
                  <Gift className="w-5 h-5 text-brand-petrol" data-id="element-22" />
                </div>
                <p className="text-[11px] font-extrabold text-brand-gold mb-1 tracking-wider uppercase" data-id="element-23">
                  🎁 BONUS {i + 1}
                </p>
                <h3 className="text-sm font-bold text-brand-graphite mb-1.5 leading-tight" data-id="element-24">
                  {bonus.title}
                </h3>
                <p className="text-xs text-brand-graphite/80 font-medium leading-snug" data-id="element-25">
                  {bonus.description}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-8 px-4 bg-brand-cream" data-id="element-26">
        <div className="max-w-4xl mx-auto" data-id="element-27">
          <h2 className="text-2xl sm:text-3xl font-serif font-extrabold text-center text-brand-graphite mb-6 uppercase" data-id="element-28">
            WHAT WILL CHANGE
          </h2>

          <div className="grid sm:grid-cols-2 gap-3" data-id="element-29">
            {[{
            emoji: '⚡',
            title: 'Save Hours Every Week',
            desc: 'Stop creating nutrition plans, educational materials, assessment forms, and client resources from scratch. Simply open the system, choose the right template, and start every consultation fully prepared.'
          }, {
            emoji: '👑',
            title: 'Deliver More Professional Consultations',
            desc: 'Evaluate clients with confidence, create personalized nutrition plans faster, and organize every stage of the consultation using a complete professional system built specifically for nutrition professionals.'
          }, {
            emoji: '🥗',
            title: 'Improve Client Results',
            desc: 'Help your clients better understand their nutrition plans, stay motivated, build healthier habits, and follow structured programs that improve long-term adherence and overall outcomes.'
          }, {
            emoji: '😊',
            title: 'Increase Client Retention',
            desc: 'Keep your clients engaged with professional educational materials, structured follow-up systems, and a more organized nutrition experience that builds trust and long-term commitment.'
          }].map((item, i) => <div key={i} className="bg-white border-l-4 border-brand-petrol p-4 rounded-r-lg shadow-sm flex gap-3 items-start" data-id="element-30">
                <div className="text-2xl shrink-0 mt-0.5" data-id="element-31">{item.emoji}</div>
                <div data-id="element-32">
                  <h3 className="text-sm sm:text-base font-bold text-brand-graphite mb-0.5 uppercase tracking-wide" data-id="element-33">
                    {item.title}
                  </h3>
                  <p className="text-brand-graphite/80 text-xs sm:text-sm font-medium leading-snug" data-id="element-34">
                    {item.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>
    </>;
}